<template>
  <v-container fluid class="gl-ledger-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab
            :href="`#tab-ledger`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Ledger
          </v-tab>
          <v-tab-item
            :value="'tab-ledger'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6"><p class="text-h5">Edit Ledger</p></v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeLedger($event, 'ledgercode')"
                        v-bind:value="initvalue.ledgercode"
                        placeholder="Ledger Code"
                        persistent-hint
                        single-line hint="Enter the ledger code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangeLedger($event, 'ledgername')"
                        v-bind:value="initvalue.ledgername"
                        placeholder="Ledger Name"
                        persistent-hint
                        single-line hint="Enter the ledger name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="['Ledger', 'Other Ledger']"
                        :value="initvalue.ledgertype"
                        outlined
                        dense
                        v-on:change="onChangeLedger($event, 'ledgertype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the ledger type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['Active', 'Inactive']"
                        :value="initvalue.ledgerstatus"
                        outlined
                        dense
                        v-on:change="onChangeLedger($event, 'ledgerstatus')"
                        placeholder="Status"
                        persistent-hint
                        single-line hint="Please choose the status">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-bind:value="initvalue.primaryCurrency"
                        v-on:change="onChangeLedger($event, 'primaryCurrency');"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Primary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the primary currency"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'THB']"
                        v-bind:value="initvalue.secondaryCurrency"
                        v-on:change="onChangeLedger($event, 'secondaryCurrency');"
                        outlined
                        dense
                        placeholder="Secondary Currency"
                        persistent-hint
                        single-line
                        hint="Please choose the secondary currency"
                      >
                      </v-select>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-switch
                            color="primary"
                            v-on:change="onChangeLedger($event, 'isDualCurrency')"
                            v-model="initvalue.isDualCurrency"
                            v-bind:value="initvalue.isDualCurrency!=null ? initvalue.isDualCurrency : false"
                            hint="Dual Currency"
                            persistent-hint
                          ></v-switch>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-switch
                            color="primary"
                            v-on:change="onChangeLedger($event, 'isTaxable')"
                            v-model="initvalue.isTaxable"
                            v-bind:value="initvalue.isTaxable!=null ? initvalue.isTaxable : false"
                            hint="Include Only Taxable"
                            persistent-hint
                          ></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                      <v-btn
                          to="/gl-ledger/list"
                          replace
                          outlined
                          color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="editGLLedger()">
                          Save
                        </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      change_ledger: {},
      photo: {},
      initvalue: {},
      primaryCurrency: null,
      secondaryCurrency: null,
      errorindex: null,
    }
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('GLLedger', ['updateGLLedgerRequest','updateGLLedgerImageRequest','updateGLLedgerPinRequest','getGLLedgersRequest']),
    async editGLLedger() {
      this.change_ledger._id = this.initvalue._id;
      console.log(this.change_ledger)
      await this.updateGLLedgerRequest(this.change_ledger);
      router.push('/gl-ledger/list');
    },
    onChangeLedger(value, field){
      this.change_ledger[field] = value;
    },
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('GLLedger', ['isReceiving']),
  },
  async created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'GLLedgerList' });
    if(this.accounts.length==0) await this.getAccountsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
